<div class="p-10 m-20 " >
  <div class="table-container">
    <table class="custom-table rounded-header">
      <thead>
        <tr>
          <th *ngFor="let item of tableHeaders" class="fs-14 font_bold cl-black">
            <div class="verticle-center justify-content-space-between icon-style">
              {{ item?.label }}
            </div>
          </th>
          <th>Status</th>
          <th>Comment</th>
        </tr>
      </thead>
      <tbody class="bg-white">
        <tr *ngFor="let program of trainingPrograms">
          <td>{{ program.hodName }}</td>
          <td>{{ program.department }}</td>
          <td>{{ program.code }}</td>
          <td>{{ program.title }}</td>
          <td>{{ program.startDate }}</td>
          <td>{{ program.endDate }}</td>
          <td>
          abc....
          </td>
          <td>
            <input type="file" class="upload-btn" />
          </td>
          <td>
            <mat-radio-group [(ngModel)]="program.status" aria-label="Select Status" class="fs-14 font_semibold">
              <mat-radio-button value="Approved" class="approve-radio">
                Approve
              </mat-radio-button>
              <mat-radio-button value="Rejected" class="reject-radio pl-10">
                Reject
              </mat-radio-button>
            </mat-radio-group>
          </td>
          
          <td>
            <span class="comment-box">{{ program.comment | slice:0:5 }}...</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
